import apiService from "./api";

const orderService = {
  // Get orders for a specific date
  getOrdersByDate(date) {
    return apiService.get(`/orders/food/store`, { date });
  },
  // Get orders by user ID and date
  getOrdersByUserId(userId, date) {
    return apiService.get(`/orders/${userId}`, { date });
  },
  // Get guest order details
  getGuestOrderDetails(orderId) {
    return apiService.get(`/orders/guest-orders/${orderId}/show`);
  },
  // Get delivery user orders
  getDeliveryUserOrders(params) {
    return apiService.get(`/orders/delivery-user-orders`, params);
  },
  // Send comment for guest order
  sendCommentGuest(data) {
    return apiService.post(`/orders/send-comment-guest`, data);
  },
  // Get delivery company monthly report
  getDeliveryCompanyMonthly(data) {
    return apiService.post(`/orders/get-delivery-company-monthly`, data);
  },
  // Get delivery company monthly report (alternative endpoint)
  getDeliveryCompanyMonthlyReport(data) {
    return apiService.post(`/orders/get-delivery-company-monthly-report`, data);
  },
  // Add additional meal
  addAdditionalMeal(data) {
    return apiService.post(`/orders/add-additional-meal`, data);
  },
  // Edit order location
  editLocation(data) {
    return apiService.post('/orders/edit-location', data);
  },
  // Remove from order list
  removeFromOrderList(list) {
    return apiService.post('/orders/remove-from-order-list', list);
  },
  // Get guest old orders
  getGuestOldOrders(resId) {
    return apiService.post('/orders/guest-old-orders', { res_id: resId });
  },
  // Create guest orders
  createGuestOrders(data) {
    return apiService.post('/orders/guest-orders', data);
  },
  // Pay guest order
  payGuest(data) {
    return apiService.post('/orders/pay-guest', data);
  },
  // Guest order pay
  guestOrderPay(data) {
    return apiService.post('/orders/guest-order-pay', data);
  },
  // Create order
  createOrder(data) {
    return apiService.post('/orders', data);
  },
  // Update order
  updateOrder(orderId, data) {
    return apiService.put(`/orders/${orderId}`, data);
  },
  // Delete order
  deleteOrder(orderId) {
    return apiService.delete(`/orders/${orderId}`);
  },
  // Get entity coordinates
  getEntityCoordinates(data) {
    return apiService.post('/get-entity-coordinates', data);
  },
  // Delivery user order status operations
  cancelDeliveryUserStatus(data) {
    return apiService.post('/orders/cancel-delivery-user-status', data);
  },
  deliveredUserStatus(data) {
    return apiService.post('/orders/delivered-user-status', data);
  },
  deliveryUserChangeStatus(data) {
    return apiService.post('/orders/delivery-user-change-status', data);
  },
  // Delivery order (not used but exists in code)
  deliveryOrder(data) {
    return apiService.post('/orders/delivery-order', data);
  },
  // Filter orders not taken
  filterNotTakenOrders(data) {
    return apiService.post('/orders/filter-not-taken-orders', data);
  },
  // Filter orders not on time
  filterNotOnTimeOrders(data) {
    return apiService.post('/orders/filter-not-on-time-orders', data);
  },
  // Change order location
  changeOrderLocation(data) {
    return apiService.post('/orders/location', data);
  },
  // Set reserved meal
  setReservedMeal(data) {
    return apiService.post('/orders/set-reserved-meal', data);
  },
  // Pay orders
  payOrders(data) {
    return apiService.post('/orders/pay', data);
  },
  // Pay group orders
  payGroupOrders(data) {
    return apiService.post('/orders/pay-group', data);
  },
  // Pay food orders
  payFoodOrders(data) {
    return apiService.post('/orders/pay-food', data);
  },
  // Store food order (v2)
  storeFoodOrder(data) {
    return apiService.post('/v2/orders/food/store', data);
  },
  // Update food order
  updateFoodOrder(orderId, data) {
    return apiService.put(`/orders/food/store/${orderId}`, data);
  },
  // Store group food order
  storeGroupFoodOrder(data) {
    return apiService.post('/orders/food/store/group', data);
  },
  // Update group food order
  updateGroupFoodOrder(orderId, data) {
    return apiService.put(`/orders/food/store/${orderId}/group`, data);
  },
};

export default orderService;
